export default __webpack_public_path__ + "static/media/explorer-subtitle-img.09fbb48f.png";